/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2022 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

/**
 * Override this component to implement:
 * - Lazy loading feature: Images will be loaded when they are visible in viewports
 * - Responisve images using picture element
 */

export function getCloudinaryImageUrl(src?: string, cloudinaryWidth?: string, isCatalogImage?: boolean) {
    if (typeof window !== "undefined") {
        const globalNotFoundImagePath = localStorage.getItem("cloudinaryGlobalNotFoundImagePath");
        const catalogNotFoundImagePath =
            localStorage.getItem("productMediumDefaultImagePath") ||
            localStorage.getItem("productLargeDefaultImagePath") ||
            localStorage.getItem("productSmallDefaultImagePath");
        const cloudinaryUrl = localStorage.getItem("cloudinaryMediaRootPath") || "";

        const addtionalRemovableText = "image/upload/";

        const parsedCloudinaryWidth = cloudinaryWidth?.replace("px", "");
        const notFoundImagePath = isCatalogImage ? catalogNotFoundImagePath : globalNotFoundImagePath;

        if (
            src &&
            (src.toLowerCase().indexOf("wwww.") > -1 ||
                (src.toLowerCase().indexOf("http") > -1 && src.toLowerCase().indexOf("res.") === -1) ||
                src.toLowerCase().indexOf("userfiles") > -1)
        ) {
            return src;
        }
        if (src && cloudinaryUrl) {
            const trimmedSrc1 = src.replace(cloudinaryUrl, "");
            const trimmedSrc2 = trimmedSrc1.replace(addtionalRemovableText, "");
            const inlcudesTransformation = trimmedSrc2.indexOf("f_") > -1 || trimmedSrc2.indexOf("w_") > -1;
            return `${cloudinaryUrl}${
                !inlcudesTransformation ? `f_auto,w_${parsedCloudinaryWidth || "auto"}/` : ""
            }${trimmedSrc2}`;
        }
        if (
            notFoundImagePath &&
            (notFoundImagePath.toLowerCase().indexOf("wwww.") > -1 ||
                (notFoundImagePath.toLowerCase().indexOf("http") > -1 &&
                    notFoundImagePath.toLowerCase().indexOf("res.") === -1) ||
                notFoundImagePath.toLowerCase().indexOf("userfiles") > -1)
        ) {
            return notFoundImagePath;
        }
        const notFoundSrc1 = notFoundImagePath?.replace(cloudinaryUrl, "");
        const notFoundSrc2 = notFoundSrc1?.replace(addtionalRemovableText, "");
        return `${cloudinaryUrl}f_auto,w_${parsedCloudinaryWidth || "auto"}/${notFoundSrc2}`;
    }
    return "";
}

export const getSEOProductImagePath = (src?: string, cloudinaryRootPath?: string, isCatalogImage?: boolean) => {
    if (typeof localStorage !== "undefined" && localStorage !== null) {
        if (src) {
            if (src.toLowerCase().indexOf("userfiles") > -1) {
                return window.location.hostname + src;
            }

            if (src.toLowerCase().indexOf("res.cloudinary") > -1) {
                return src;
            }
        }
        const globalNotFoundImagePath = localStorage.getItem("cloudinaryGlobalNotFoundImagePath");
        const catalogNotFoundImagePath =
            localStorage.getItem("productMediumDefaultImagePath") ||
            localStorage.getItem("productLargeDefaultImagePath") ||
            localStorage.getItem("productSmallDefaultImagePath");
        if (!src) {
            return isCatalogImage ? catalogNotFoundImagePath : globalNotFoundImagePath;
        }
        return cloudinaryRootPath + src;
    }
};
